import type { ElementType } from '../types';
import { affinityLabel } from '../specialCompetitions';

/** Tournament identity for each elemental national side. This deliberately
 * differs from the small affinity pills used on player cards. */
export function AffinityCrest({ element, size = 'row' }: { element: ElementType; size?: 'row' | 'hero' }) {
  const src = `/affinity-crest-${element.toLowerCase()}.png`;
  return <span className={`affinity-crest affinity-crest--${element.toLowerCase()} affinity-crest--${size}`} role="img" aria-label={`Selección ${affinityLabel(element)}`}>
    <img src={src} alt="" />
  </span>;
}
